(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maison-vynce-pulse-set"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initEarlyBird = (scope = document) => {
      const candidates = [];
      if (scope instanceof Element && scope.matches('.mv-early-bird')) candidates.push(scope);
      scope.querySelectorAll?.('.mv-early-bird').forEach((element) => candidates.push(element));

      candidates.forEach((offer) => {
        if (offer.dataset.mvEarlyBirdMotion === 'true') return;
        offer.dataset.mvEarlyBirdMotion = 'true';

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          offer.classList.add('mv-eb-visible');
          return;
        }

        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            offer.classList.add('mv-eb-visible');
            observer.disconnect();
          });
        }, { threshold: 0.16, rootMargin: '0px 0px -10% 0px' });

        observer.observe(offer);
      });
    };

    initEarlyBird();
    document.addEventListener('shopify:section:load', (event) => {
      initEarlyBird(event.target instanceof Element ? event.target : document);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
